module.exports = __webpack_public_path__ + "img/newcredit_header.dbf5e6ab.svg";